import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import './style.scss'

import { Button, Empty, Form, Input, InputNumber, Select, Space } from 'antd'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { useAppSelector } from 'hooks/useRedux'
import { useEffect, useState } from 'react'
import { thunkNationlity } from 'features/Nationlity/nationlitySlice'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  convertToOptions,
  findObjectInArray,
  formatTaxCode,
  removeAccents,
} from 'general/utils/Utils'
import { useTranslation } from 'react-i18next'
import {
  REGEX_IDENTIFY,
  REGEX_MST,
  regexLong,
} from 'general/constants/AppRegex'
import SelectOptions from 'general/constants/SelectOptions'
import { thunkIncomeItem } from 'features/IncomeItem/incomeItemSlice'
import { RangePickerCustom } from 'features/TaxDeductionDocuments/styled'
import locale from 'antd/es/date-picker/locale/vi_VN'
import { EmployeeStatusResidenceData } from 'general/constants/AppConstants'
ModalValidateUploadADExcel.prototype = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  submit: PropTypes.func,
}

function ModalValidateUploadADExcel(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { formatNumber } = useAppSelector((state) => state?.systemConfig)

  const {
    show,
    onHide,
    submit,
    datas = [],
    listNationality = [],
    setListNationality = () => {},
    listIncomeItem = [],
    setListIncomeItem = () => {},
  } = props

  const [form] = Form.useForm()

  const onFinish = async (values) => {
    console.log('Received values of form:', values)
    await submit(values)
  }

  const getAllNationality = async () => {
    if (setListNationality && listNationality.length == 0) {
      const data = unwrapResult(await dispatch(thunkNationlity({})))
      setListNationality(
        convertToOptions(data?.data ?? [], 'nationalityId', 'nationalityName'),
      )
    }
  }

  const getAllIncomeItem = async (body) => {
    if (setListIncomeItem && listIncomeItem.length == 0) {
      const data = unwrapResult(await dispatch(thunkIncomeItem(body)))
      setListIncomeItem(convertToOptions(data?.data?.items, 'name', 'name'))
    }
  }

  useEffect(() => {
    if (datas?.length) {
      form.setFieldsValue({
        datas,
      })
    }
  }, [datas])

  useEffect(() => {
    getAllNationality()
    getAllIncomeItem({})
    // getAllCity({ countryId: 1 })
  }, [])

  const maxInput = 999999999999

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      className="ModalValidateUploadInvoiceExcel"
    >
      <Modal.Header closeButton>
        <Modal.Title>Bảng kiểm tra upload excel</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          style={{
            maxHeight: 900,
            overflowY: 'auto',
            padding: '0px 7px',
            position: 'relative',
            left: -7,
          }}
        >
          <Form
            name="dynamic_form_nest_item"
            onFinish={onFinish}
            autoComplete="off"
            form={form}
            layout="vertical" // 👈 cái này giúp có label phía trên
          >
            <Form.List name="datas" className="form-row">
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => {
                    const { key, name, ...restField } = field

                    return (
                      <Space key={key} className="form-row" align="start">
                        <Form.Item
                          {...restField}
                          name={[name, 'taxpayersName']}
                          label="Họ và tên"
                          rules={[
                            // {
                            //   required: true,
                            //   message: 'Họ và tên không thể để trống',
                            // },
                            () => ({
                              validator(_, value) {
                                if (!value) {
                                  return Promise.reject(
                                    new Error('Họ và tên không thể để trống'),
                                  )
                                }
                                if (
                                  value &&
                                  value.trim() &&
                                  value.trim().length > 400
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      ` ${t('Họ và tên có độ dài tối đa là 400 ký tự')}`,
                                    ),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <Input placeholder="Nhập họ và tên" />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'employeeTaxCode']}
                          label="Mã số thuế"
                          normalize={(value) => value?.trim()}
                          rules={[
                            {
                              validator(_, value) {
                                if (!value) return Promise.resolve()

                                const regex = new RegExp(REGEX_MST)
                                if (!regex.test(value.trim())) {
                                  return Promise.reject(
                                    new Error(t('taxpayer.validateTaxCode')),
                                  )
                                }

                                return Promise.resolve()
                              },
                            },
                          ]}
                        >
                          <Input placeholder="Nhập mã số thuế" />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'employeeNationality']}
                          label="Quốc tịch"
                          rules={[]}
                        >
                          <Select
                            placeholder="Chọn/Nhập quốc tịch"
                            options={listNationality}
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                              removeAccents(option?.label ?? '')
                                .toLowerCase()
                                .includes(removeAccents(input).toLowerCase())
                            }
                            notFoundContent={
                              <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={t('taxDeduction.noData')}
                              />
                            }
                          ></Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'employeeStatusResidence']}
                          label="Cá nhân cư trú/Cá nhân không cư trú"
                          rules={[
                            () => ({
                              validator(_, value) {
                                if (value == null) {
                                  return Promise.reject(
                                    new Error('Không thể để trống'),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <Select
                            placeholder="Cá nhân cư trú/Cá nhân không cư trú"
                            options={EmployeeStatusResidenceData}
                            notFoundContent={
                              <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={t('taxDeduction.noData')}
                              />
                            }
                          ></Select>
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'employeeAddress']}
                          label="Địa chỉ"
                          rules={[
                            // {
                            //   required: true,
                            //   message: 'Họ và tên không thể để trống',
                            // },
                            () => ({
                              validator(_, value) {
                                if (!value) {
                                  return Promise.reject(
                                    new Error('Địa chỉ không thể để trống'),
                                  )
                                }
                                if (
                                  value &&
                                  value.trim() &&
                                  value.trim().length > 400
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      ` ${t('Địa chỉ có độ dài tối đa là 400 ký tự')}`,
                                    ),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <Input placeholder="Nhập địa chỉ" />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'employeePhone']}
                          label="Điện thoại liên hệ"
                          rules={[
                            () => ({
                              validator(_, value) {
                                if (!value) {
                                  return Promise.reject(
                                    new Error(
                                      'Điện thoại liên hệ không thể để trống',
                                    ),
                                  )
                                }
                                const regex = new RegExp(
                                  regexLong.REGEX_PHONE_NUMBER,
                                )
                                if (value && !regex.test(value.trim())) {
                                  return Promise.reject(
                                    new Error(
                                      ` ${t('taxpayer.typeFeild', { key: t('taxpayer.phone') })}`,
                                    ),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <Input placeholder="Nhập điện thoại liên hệ" />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'employeeIdentification']}
                          label="CCCD/Hộ chiếu"
                          dependencies={[[name, 'employeeTaxCode']]}
                          normalize={(value) => value?.trim()}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                let taxCode = getFieldValue([
                                  'data',
                                  name,
                                  'employeeTaxCode',
                                ])

                                if (!value?.trim() && !taxCode?.trim()) {
                                  return Promise.reject(
                                    new Error(
                                      'Không thể để trống CCCD/Hộ chiếu',
                                    ),
                                  )
                                }

                                if (
                                  value &&
                                  value.trim() &&
                                  value.trim().length > 12
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      'CCCD/Hộ chiếu có độ dài lớn nhất là 12 ký tự',
                                    ),
                                  )
                                }

                                if (
                                  value?.trim() &&
                                  !REGEX_IDENTIFY.REGEX_CCCD.test(
                                    value?.trim(),
                                  ) &&
                                  !REGEX_IDENTIFY.REGEX_PASSPORT.test(
                                    value.trim(),
                                  )
                                ) {
                                  return Promise.reject(
                                    new Error('Không đúng định dạng CCCD/HC'),
                                  )
                                }

                                if (value) {
                                  const regex =
                                    /^([A-Z0-9]{8,9}|\d{9}|\d{12})$/i

                                  if (!regex.test(value.trim())) {
                                    return Promise.reject(
                                      new Error('Không đúng định dạng CCCD/HC'),
                                    )
                                  }
                                }

                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <Input placeholder="Nhập CCCD/HC" />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'income']}
                          label="[13] Khoản thu nhập"
                          rules={[
                            () => ({
                              validator(_, value) {
                                if (!value) {
                                  return Promise.reject(
                                    new Error('Không thể để trống'),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <Select
                            placeholder="Chọn/Nhập khoản thu nhập"
                            options={listIncomeItem}
                            // allowClear
                            showSearch
                            filterOption={(input, option) =>
                              removeAccents(option?.label ?? '')
                                .toLowerCase()
                                .includes(removeAccents(input).toLowerCase())
                            }
                            notFoundContent={
                              <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={t('taxDeduction.noData')}
                              />
                            }
                          ></Select>
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'insurance']}
                          label="[14] Khoản đóng bảo hiểm bắt buộc"
                          rules={[
                            // {
                            //   required: true,
                            //   message: 'Họ và tên không thể để trống',
                            // },
                            () => ({
                              validator(_, value) {
                                if ((value = null)) {
                                  return Promise.reject(
                                    new Error('Không thể để trống'),
                                  )
                                }
                                if (value && (value > maxInput || value < 0)) {
                                  return Promise.reject(
                                    new Error(`Dữ liệu không hợp lệ`),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <InputNumber
                            controls={false}
                            className="input-right"
                            style={{ width: '100%' }}
                            placeholder="Nhập khoản đóng bảo hiểm bắt buộc"
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, '')
                            }
                            min={0}
                            max={maxInput}
                            maxLength={15}
                          />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'benevolenceDonations']}
                          label="[15] Khoản từ thiện, nhân đạo, khuyến học"
                          rules={[
                            // {
                            //   required: true,
                            //   message: 'Họ và tên không thể để trống',
                            // },
                            () => ({
                              validator(_, value) {
                                if (value == null) {
                                  return Promise.reject(
                                    new Error('Không thể để trống'),
                                  )
                                }
                                if (value && (value > maxInput || value < 0)) {
                                  return Promise.reject(
                                    new Error(`Dữ liệu không hợp lệ`),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <InputNumber
                            controls={false}
                            className="input-right"
                            style={{ width: '100%' }}
                            placeholder="Nhập Khoản từ thiện, nhân đạo, khuyến học"
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, '')
                            }
                            min={0}
                            max={maxInput}
                            maxLength={15}
                          />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'incomeDate']}
                          label="[16] Thời điểm trả thu nhập"
                          rules={[
                            () => ({
                              validator(_, value) {
                                //required
                                if (value == null) {
                                  return Promise.reject(
                                    new Error(
                                      t('accountingDocuments.required'),
                                    ),
                                  )
                                }

                                if (
                                  !(
                                    value[0] &&
                                    value[1] &&
                                    dayjs(value[0]).year() ==
                                      dayjs(value[1]).year()
                                  )
                                ) {
                                  return Promise.reject(
                                    new Error(t('accountingDocuments.inyear')),
                                  )
                                }

                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <RangePickerCustom
                            style={{}}
                            locale={locale}
                            format={'MM-YYYY'}
                            picker={'month'}
                            //   placeholder={
                            //     itemFeild?.placeholder?.[language] ??
                            //     t('accountingDocuments.plSelectdate')
                            //   }
                          />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'totalTaxableIncome']}
                          label="[17] Tổng thu nhập chịu thuế phải khấu trừ"
                          dependencies={[[name, 'totalDeductedTax']]}
                          rules={[
                            // {
                            //   required: true,
                            //   message: 'Họ và tên không thể để trống',
                            // },
                            () => ({
                              validator(_, value) {
                                if (value == null) {
                                  return Promise.reject(
                                    new Error('Không thể để trống'),
                                  )
                                }
                                if (value && (value > maxInput || value < 0)) {
                                  return Promise.reject(
                                    new Error(`Dữ liệu không hợp lệ`),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <InputNumber
                            controls={false}
                            className="input-right"
                            style={{ width: '100%' }}
                            placeholder="Nhập Khoản từ thiện, nhân đạo, khuyến học"
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, '')
                            }
                            min={0}
                            max={maxInput}
                            maxLength={15}
                          />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'totalTaxIncome']}
                          label="[18] Tổng thu nhập tính thuế"
                          rules={[
                            // {
                            //   required: true,
                            //   message: 'Họ và tên không thể để trống',
                            // },
                            () => ({
                              validator(_, value) {
                                if (value == null) {
                                  return Promise.reject(
                                    new Error('Không thể để trống'),
                                  )
                                }
                                if (value && (value > maxInput || value < 0)) {
                                  return Promise.reject(
                                    new Error(`Dữ liệu không hợp lệ`),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <InputNumber
                            controls={false}
                            className="input-right"
                            style={{ width: '100%' }}
                            placeholder="Nhập tổng thu nhập tính thuế"
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, '')
                            }
                            min={0}
                            max={maxInput}
                            maxLength={15}
                          />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'totalDeductedTax']}
                          label="[19] Số thuế thu nhập cá nhân đã khấu trừ"
                          dependencies={[[name, 'totalTaxableIncome']]}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (value == null) {
                                  return Promise.reject(
                                    new Error('Không thể để trống'),
                                  )
                                }
                                if (value && (value > maxInput || value < 0)) {
                                  return Promise.reject(
                                    new Error(`Dữ liệu không hợp lệ`),
                                  )
                                }
                                if (value) {
                                  let totalTaxableIncome =
                                    form.getFieldValue('datas')?.[index]
                                      ?.totalTaxableIncome
                                  if (value > totalTaxableIncome) {
                                    return Promise.reject(
                                      new Error(
                                        `Chỉ tiêu [19] phải nhỏ hơn hoặc bằng chỉ tiêu [17]`,
                                      ),
                                    )
                                  }
                                }
                                return Promise.resolve()
                              },
                            }),

                            // {
                            //   required: true,
                            //   message: 'Họ và tên không thể để trống',
                            // },
                          ]}
                        >
                          <InputNumber
                            controls={false}
                            className="input-right"
                            style={{ width: '100%' }}
                            placeholder="Nhập số thuế thu nhập cá nhân đã khấu trừ"
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, '')
                            }
                            min={0}
                            max={maxInput}
                            maxLength={15}
                          />
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, 'note']}
                          label="Ghi chú"
                          rules={[
                            // {
                            //   required: true,
                            //   message: 'Họ và tên không thể để trống',
                            // },
                            () => ({
                              validator(_, value) {
                                if (
                                  value &&
                                  value.trim() &&
                                  value.trim().length > 255
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      ` ${t('Ghi chú có độ dài tối đa là 255 ký tự')}`,
                                    ),
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                        >
                          <Input placeholder="Nhập ghi chú" />
                        </Form.Item>

                        <MinusCircleOutlined
                          className="remove-icon"
                          title="Xóa"
                          onClick={() => remove(name)}
                        />
                      </Space>
                    )
                  })}

                  <br></br>
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      style={{ width: 160, marginTop: 25, marginLeft: -5 }}
                      block
                      icon={<PlusOutlined />}
                    >
                      Thêm chứng từ
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                id="submitFormAD"
                style={{ display: 'none' }}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn btn-success px-8 mr-4"
          onClick={() => {
            document.getElementById('submitFormAD').click()
          }}
        >
          Tiếp tục tải lên
        </button>
        <button className="btn btn-outline-secondary px-8" onClick={onHide}>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalValidateUploadADExcel
